@let skillsProfileData = skillsProfileData$ | async;

@if (skillsProfileData !== undefined && skillsProfileData !== null) {
    <div class="mm-skill-profile">
        @if (skillsProfileData.topics.length >= 2) {
            <div class="mm-skill-profile-popup-chart-documentation-link">
                <mm-help-icon-link [title]="'learningGoal.insightsPopup.skillsProfile.helpButtonTitle' | translate"
                                   [link]="'https://taskbase.atlassian.net/wiki/spaces/Micromate/pages/1537839329/Das+Kompetenzprofil'"></mm-help-icon-link>
            </div>
            <div class="mm-skill-profile-popup-content" #scrollContainer>
                <div class="mm-skill-profile-popup-content-area">
                    @if (skillsProfileData.topics.length > 2) {
                        <div class="mm-skill-profile-popup-chart">
                            <mm-skill-profile-radar-diagram [topicsData]="skillsProfileData.topics"
                                                            [learningGoal]="skillsProfileData.learningGoal"
                                                            class="mm-skill-profile-popup-chart-element"></mm-skill-profile-radar-diagram>
                        </div>
                    } @else {
                        <div class="mm-skill-profile-popup-chart mm-skill-profile-popup-chart-bar">
                            <mm-skill-profile-bar-diagram [topicsData]="skillsProfileData.topics"
                                                          [learningGoal]="skillsProfileData.learningGoal"
                                                          class="mm-skill-profile-popup-chart-element"></mm-skill-profile-bar-diagram>
                        </div>
                    }
                </div>
            </div>
        } @else {
            <app-message-box type="info" class="mm-skill-profile-popup-no-topic-message"
                             [content]="'learningGoal.insightsPopup.skillsProfile.noTopicMessage' | translate"></app-message-box>
        }
    </div>
}
